// MassActionsAds.jsx
import React, { useState } from "react";
import s from "../../admin_styles/UserSearch.module.css";

export default function AdsMassActionsAds({ selectedAds = [], onCloseAll }) {
  const [showModal, setShowModal] = useState(false);

  if (!selectedAds || selectedAds.length === 0) return null;

  const handleClose = () => {
    setShowModal(false);
    if (onCloseAll) onCloseAll(); // опционально, если захочешь сбрасывать выделение
  };

  return (
    <div className={s.massActions}>
      <button onClick={() => setShowModal(true)}>
        Выбрано объявлений: {selectedAds.length}
      </button>

      {showModal && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent} style={{ maxWidth: 900 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ margin: 0 }}>Выбранные объявления ({selectedAds.length})</h3>
              <button className={s.modalClose} onClick={handleClose}>✕</button>
            </div>

            <div
              style={{
                marginTop: 10,
                border: "1px solid #e5e7eb",
                borderRadius: 6,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "90px 180px 140px 1fr",
                  gap: 8,
                  padding: "8px 10px",
                  background: "#f9fafb",
                  fontWeight: 600,
                }}
              >
                <div>ID</div>
                <div>Ad ID</div>
                <div>Avito ID</div>
                <div>Title</div>
              </div>

              <div
                style={{
                  maxHeight: 420,
                  overflow: "auto",
                }}
              >
                {selectedAds.map((a) => {
                  const title = a?.data?.Title || a?.data?.title || "";
                  return (
                    <div
                      key={a.fiveads_id}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "90px 180px 140px 1fr",
                        gap: 8,
                        padding: "8px 10px",
                        borderTop: "1px solid #f1f5f9",
                        alignItems: "center",
                      }}
                    >
                      <div>{a.fiveads_id}</div>
                      <div>{a.ad_id || "-"}</div>
                      <div>{a.avito_id ?? "-"}</div>
                      <div
                        title={title}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {title || "—"}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={s.modalActions} style={{ marginTop: 10 }}>
              {/* Кнопки действий добавим позже */}
              <button onClick={handleClose}>Закрыть</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
